import { cx } from '@libs/classnames';
import styles from './MainBgOverlay.module.css';

export type MainBgOverlayProps = {
  className?: string;
};

export function MainBgOverlay({ className }: MainBgOverlayProps) {
  return (
    <div className={cx(styles.root, className)} />
  );
}
